/* REIDWOOD Trail Cinema — ported 1:1 from trail-cinema-mockup.html for Shopify.
   Same motion system; cart/search/product data now come from Shopify APIs. */
(function(){
'use strict';
try{ gsap.registerPlugin(ScrollTrigger, SplitText); }catch(e){}
/* Preserve the browser's native back-button position. Returning shoppers should
   land where they left off instead of being forced back to the top. */
try{ history.scrollRestoration = 'auto'; }catch(e){}

const $ = s => document.querySelector(s);
const $$ = s => Array.from(document.querySelectorAll(s));
const money = c => '$' + (c/100).toFixed(2);
const rewardMoney = c => money(c).replace(/\.00$/, '');
const esc = v => String(v == null ? '' : v).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
const TPL = (document.body.className.match(/tpl-([a-z0-9_-]+)/) || [,''])[1];
const CFG = window.RW_CONFIG || {};

/* ================= LENIS ================= */
/* if a vendor lib is blocked (ad-blocker, flaky network), fall back to native
   scrolling instead of throwing here and killing the cart wiring below */
let lenis;
try{
  lenis = new Lenis({ lerp: 0.09 });
  lenis.on('scroll', ScrollTrigger.update);
  gsap.ticker.add(t => lenis.raf(t * 1000));
  gsap.ticker.lagSmoothing(0);
}catch(e){
  lenis = { on(){}, raf(){}, scrollTo(t, o){ try{ typeof t === 'number' ? window.scrollTo({ top: t, behavior: 'smooth' }) : t.scrollIntoView({ behavior: 'smooth' }); }catch(_){} } };
}

/* ================= TOAST ================= */
let toastT;
function toast(msg){
  const t = $('#toast'); if (!t) return;
  t.textContent = msg || '';
  t.classList.add('on'); clearTimeout(toastT);
  toastT = setTimeout(() => t.classList.remove('on'), 2200);
}

/* Native navigation is intentionally preserved. The old full-screen wipe added
   a visible delay to every product and checkout-adjacent click. */

/* ================= CART (Shopify AJAX API) ================= */
let CART = null;
const drawer = $('#drawer'), ovl = $('#ovl'), packBtn = $('#packBtn');
const RCFG = CFG.rewards || {};
let rewardGiftSyncing = false;
let rewardGiftSyncPromise = null;

function isGiftVariant(item){
  return !!(item && RCFG.gift && String(item.variant_id) === String(RCFG.gift.variantId));
}
function isRewardGift(item){
  /* The reward now has its own gift-only Shopify variant. Any appearance of
     that variant is a reward line; the private property still records that
     this theme added it, but paid ponchos use a different variant ID. */
  return isGiftVariant(item);
}
function rewardState(cart){
  const paid = ((cart && cart.items) || []).filter(i => !isGiftVariant(i));
  const subtotal = paid.reduce((sum, i) => sum + (+i.original_line_price || 0), 0);
  const giftLine = ((cart && cart.items) || []).find(isRewardGift);
  return {
    subtotal,
    shipping: !!CFG.freeShipping,
    percent: subtotal >= (+RCFG.percentThreshold || 10000),
    bonus: subtotal >= (+RCFG.bonusThreshold || 25000),
    gift: subtotal >= (+RCFG.giftThreshold || 35000),
    top: subtotal >= (+RCFG.topThreshold || 50000),
    giftApplied: !!(giftLine && giftLine.quantity === 1 && giftLine.final_line_price === 0)
  };
}
function rewardNext(state){
  if (!state.percent){
    const away = (+RCFG.percentThreshold || 10000) - state.subtotal;
    return {
      key: 'percent', now: state.subtotal, max: +RCFG.percentThreshold || 10000,
      text: `Free U.S. shipping is included. Add ${money(away)} more in eligible merchandise to get ${RCFG.percent}% off.`,
      short: `${money(away)} TO ${RCFG.percent}% OFF`,
      aria: `${money(away)} away from ${RCFG.percent}% off`
    };
  }
  if (!state.bonus){
    const away = RCFG.bonusThreshold - state.subtotal;
    return { key:'bonus', now:state.subtotal, max:RCFG.bonusThreshold,
      text:`${RCFG.percent}% off unlocked. Add ${money(away)} more to get a ${rewardMoney(RCFG.bonusAmount)} cart bonus.`,
      short:`${money(away)} TO ${rewardMoney(RCFG.bonusAmount)} BONUS`, aria:`${money(away)} away from a ${rewardMoney(RCFG.bonusAmount)} cart bonus` };
  }
  if (!state.gift){
    const away = RCFG.giftThreshold - state.subtotal;
    return { key:'gift', now:state.subtotal - RCFG.bonusThreshold, max:RCFG.giftThreshold - RCFG.bonusThreshold,
      text:`${RCFG.percent}% off + ${rewardMoney(RCFG.bonusAmount)} cart bonus unlocked. Add ${money(away)} more to get a free ${RCFG.gift.title}.`,
      short:`${money(away)} TO FREE PONCHO`, aria:`${money(away)} away from the free ${RCFG.gift.title}` };
  }
  if (!state.top){
    const away = RCFG.topThreshold - state.subtotal;
    return { key:'top', now:state.subtotal - RCFG.giftThreshold, max:RCFG.topThreshold - RCFG.giftThreshold,
      text:`${RCFG.percent}% off + ${rewardMoney(RCFG.bonusAmount)} cart bonus + free ${RCFG.gift.title} unlocked. Add ${money(away)} more to make the cart bonus ${rewardMoney(RCFG.topAmount)} total.`,
      short:`${money(away)} TO ${rewardMoney(RCFG.topAmount)} TOTAL BONUS`, aria:`${money(away)} away from a ${rewardMoney(RCFG.topAmount)} total cart bonus` };
  }
  return { key:'', now:1, max:1, text:`All rewards unlocked: free shipping, ${RCFG.percent}% off, a ${rewardMoney(RCFG.topAmount)} total cart bonus, and a free poncho.`, short:'ALL REWARDS UNLOCKED', aria:'All pack rewards unlocked' };
}
function renderRewards(cart){
  if (!RCFG.enabled || !cart) return;
  const state = rewardState(cart), next = rewardNext(state);
  const on = { shipping:state.shipping, percent:state.percent, bonus:state.bonus, gift:state.gift, top:state.top };
  $$('[data-rw-rewards]').forEach(panel => {
    const nextEl = panel.querySelector('[data-rw-next]');
    if (nextEl) nextEl.textContent = next.text;
    const progress = panel.querySelector('[data-rw-progress]');
    const ratio = Math.max(0, Math.min(1, next.max ? next.now / next.max : 0));
    if (progress){
      progress.setAttribute('aria-valuemin','0');
      progress.setAttribute('aria-valuemax', String(next.max));
      progress.setAttribute('aria-valuenow', String(Math.min(next.now, next.max)));
      progress.setAttribute('aria-valuetext', next.aria);
      const fill = progress.querySelector('[data-rw-progress-fill]');
      if (fill) fill.style.transform = `scaleX(${ratio})`;
    }
    panel.querySelectorAll('[data-rw-step]').forEach(step => {
      const key = step.dataset.rwStep, qualified = !!on[key];
      step.classList.toggle('is-unlocked', qualified);
      step.classList.toggle('is-locked', !qualified);
      step.classList.toggle('is-current', !qualified && key === next.key);
      const stateEl = step.querySelector('[data-rw-step-state]');
      const statusEl = step.querySelector('[data-rw-step-status]');
      if (stateEl) stateEl.textContent = qualified ? '✓' : step.dataset.rwNumber;
      if (statusEl){
        if (key === 'shipping' && qualified) statusEl.textContent = 'Included';
        else if (key === 'gift' && state.giftApplied) statusEl.textContent = 'Added free';
        else statusEl.textContent = qualified ? 'Unlocked' : step.dataset.rwLockedCopy;
      }
    });
    const gift = panel.querySelector('[data-rw-gift]');
    if (gift){
      gift.hidden = !state.gift;
      const kicker = gift.querySelector('[data-rw-gift-kicker]');
      if (kicker) kicker.textContent = state.giftApplied ? 'Added free to your pack' : 'Unlocked reward';
    }
  });
  $$('[data-rw-pdp]').forEach(panel => {
    const nextEl = panel.querySelector('[data-rw-pdp-next]');
    if (nextEl) nextEl.textContent = next.text;
    panel.querySelectorAll('[data-rw-pdp-step]').forEach(step => step.classList.toggle('is-qualified', !!on[step.dataset.rwPdpStep]));
  });
  const stickyReward = $('#sbReward');
  if (stickyReward) stickyReward.textContent = next.short;
}
async function readCart(){
  const r = await fetch('/cart.js');
  if (!r.ok) throw new Error('cart fetch failed');
  return r.json();
}
async function rawCartChange(key, quantity){
  const r = await fetch('/cart/change.js', { method:'POST', headers:{ 'Content-Type':'application/json' }, body:JSON.stringify({ id:key, quantity }) });
  if (!r.ok) throw new Error('cart change failed');
}
function setRewardGiftSyncing(on){
  rewardGiftSyncing = on;
  document.documentElement.classList.toggle('rw-reward-syncing', on);
  $$('a[href="/checkout"],button[name="checkout"]').forEach(el => {
    if (on){ el.setAttribute('aria-disabled','true'); el.setAttribute('aria-busy','true'); }
    else { el.removeAttribute('aria-disabled'); el.removeAttribute('aria-busy'); }
  });
}
document.addEventListener('click', e => {
  if (!rewardGiftSyncing) return;
  const checkout = e.target.closest('a[href="/checkout"],button[name="checkout"]');
  if (!checkout) return;
  e.preventDefault(); e.stopImmediatePropagation();
  toast('Updating your free reward…');
}, true);
document.addEventListener('submit', e => {
  if (!rewardGiftSyncing || !e.submitter || e.submitter.name !== 'checkout') return;
  e.preventDefault(); e.stopImmediatePropagation();
  toast('Updating your free reward…');
}, true);
async function syncRewardGift(cart){
  if (!RCFG.enabled || !RCFG.backendLive || !RCFG.giftAutoAdd || !RCFG.gift || !RCFG.gift.valid || !RCFG.gift.variantId) return { cart, changed:false };
  const state = rewardState(cart);
  const marked = (cart.items || []).filter(isGiftVariant);
  if (!state.gift){
    try{ sessionStorage.removeItem('rw_reward_gift_rejected'); }catch(e){}
    if (!marked.length) return { cart, changed:false };
    setRewardGiftSyncing(true);
    try{ for (const line of marked) await rawCartChange(line.key, 0); return { cart:await readCart(), changed:true }; }
    finally{ setRewardGiftSyncing(false); }
  }
  const valid = marked.length === 1 && marked[0].quantity === 1 && marked[0].final_line_price === 0;
  if (valid) return { cart, changed:false };
  setRewardGiftSyncing(true);
  try{
    if (marked.length){
      for (const line of marked) await rawCartChange(line.key, 0);
      try{ sessionStorage.setItem('rw_reward_gift_rejected','1'); }catch(e){}
      toast('Your free reward was not added because checkout did not price it at $0.');
      return { cart:await readCart(), changed:true };
    }
    let rejected = false; try{ rejected = sessionStorage.getItem('rw_reward_gift_rejected') === '1'; }catch(e){}
    if (rejected) return { cart, changed:false };
    const add = await fetch('/cart/add.js', { method:'POST', headers:{ 'Content-Type':'application/json' },
      body:JSON.stringify({ items:[{ id:+RCFG.gift.variantId, quantity:1, properties:{ _rw_reward_gift:'1' } }] }) });
    if (!add.ok) throw new Error('reward add failed');
    let checked = await readCart();
    const gift = (checked.items || []).find(isGiftVariant);
    if (gift && gift.quantity === 1 && gift.final_line_price === 0) return { cart:checked, changed:true };
    for (const line of (checked.items || []).filter(isGiftVariant)) await rawCartChange(line.key, 0);
    try{ sessionStorage.setItem('rw_reward_gift_rejected','1'); }catch(e){}
    toast('Your free reward was not added because checkout did not price it at $0.');
    return { cart:await readCart(), changed:true };
  }catch(e){
    try{ sessionStorage.setItem('rw_reward_gift_rejected','1'); }catch(_){}
    toast('The free reward could not be verified, so it was not added.');
    return { cart:await readCart().catch(() => cart), changed:false };
  }finally{ setRewardGiftSyncing(false); }
}
async function serializedRewardGiftSync(cart){
  if (rewardGiftSyncPromise){
    try{ await rewardGiftSyncPromise; }catch(e){}
    return { cart:await readCart().catch(() => cart), changed:false };
  }
  rewardGiftSyncPromise = syncRewardGift(cart);
  try{ return await rewardGiftSyncPromise; }
  finally{ rewardGiftSyncPromise = null; }
}
function openDrawer(){
  if (drawer){ drawer.classList.add('show'); drawer.removeAttribute('inert'); drawer.setAttribute('aria-hidden','false'); }
  if (ovl) ovl.classList.add('show');
  if (packBtn) packBtn.setAttribute('aria-expanded','true');
}
function closeDrawer(){
  if (drawer){ drawer.classList.remove('show'); drawer.setAttribute('aria-hidden','true'); drawer.setAttribute('inert',''); }
  if (ovl) ovl.classList.remove('show');
  if (packBtn) packBtn.setAttribute('aria-expanded','false');
}
async function cartFetch(){
  try{
    CART = await readCart();
    const synced = await serializedRewardGiftSync(CART);
    CART = synced.cart;
    if (synced.changed && TPL === 'cart') { location.reload(); return; }
    renderCart();
  }catch(e){ toast('Cart could not refresh. Please try again.'); }
}
async function cartAdd(id, qty){
  id = +id; qty = qty || 1;
  if (RCFG.gift && String(id) === String(RCFG.gift.variantId)){
    toast('This Pack Rewards item is added automatically when your cart qualifies.');
    return;
  }
  /* stack onto an existing line instead of ever creating a duplicate row */
  const line = CART && CART.items && CART.items.find(i =>
    i.variant_id === id && (!i.properties || !Object.keys(i.properties).length));
  if (line){
    await cartChange(line.key, line.quantity + qty);
    openDrawer(); toast('Added to pack');
    if (window.RW_CAPT_AFTER_ADD){ window.RW_CAPT_AFTER_ADD(); window.RW_CAPT_AFTER_ADD = null; }
    return;
  }
  const r = await fetch('/cart/add.js', { method:'POST', headers:{ 'Content-Type':'application/json' },
    body: JSON.stringify({ id: id, quantity: qty }) });
  if (r.ok){ await cartFetch(); openDrawer(); toast('Added to pack');
    if (window.RW_CAPT_AFTER_ADD){ window.RW_CAPT_AFTER_ADD(); window.RW_CAPT_AFTER_ADD = null; } }
  else { const err = await r.json().catch(() => ({})); toast(err.description || 'Could not add that'); }
}
async function cartChange(key, qty){
  await rawCartChange(key, qty);
  await cartFetch();
}
function renderCart(){
  if (!CART) return;
  renderRewards(CART);
  if (packBtn) packBtn.textContent = 'Pack · ' + CART.item_count;
  const body = $('#dBody'), foot = $('#dFoot');
  if (!body || !foot) return;
  if (!CART.items.length){
    body.innerHTML = '<div class="d-empty"><div class="display">Pack is empty</div>Fix that. The trail does not wait.<br><br><a class="btn" href="/collections/all-gear">Shop the kit</a></div>';
    foot.innerHTML = '';
    return;
  }
  const inCart = new Set(CART.items.map(i => i.product_id));
  const sugg = (window.RW_UPSELL || []).filter(u => !inCart.has(u.pid)).slice(0, 2);
  const hasInvalidGift = CART.items.some(i => isGiftVariant(i) && !(i.final_line_price === 0 && i.quantity === 1));
  body.innerHTML = CART.items.map(i => {
    const gift = isGiftVariant(i), freeGift = gift && i.final_line_price === 0 && i.quantity === 1;
    return `<div class="d-item${freeGift ? ' d-item--reward' : ''}">
      <img src="${i.image || ''}" alt="">
      <div class="inf">
        <div class="t">${esc(gift && RCFG.gift.title ? RCFG.gift.title : i.product_title)}${freeGift ? ' <span class="d-reward-badge">FREE REWARD</span>' : (gift ? ' <span class="d-reward-badge">UNAVAILABLE</span>' : '')}</div>
        <div class="pr">${freeGift ? '<s>' + money(i.original_line_price) + '</s> <b>FREE</b>' : money(i.final_line_price) + (i.original_line_price > i.final_line_price ? ' <s>' + money(i.original_line_price) + '</s>' : '')}</div>
        ${freeGift ? '<div class="d-reward-lock">Quantity 1 · reward item</div>' : (gift ? '<div class="d-reward-lock">Reward unavailable · remove before checkout</div>' : `<div class="qty"><button data-ck="${esc(i.key)}" data-cq="${i.quantity - 1}">−</button><span>${i.quantity}</span><button data-ck="${esc(i.key)}" data-cq="${i.quantity + 1}">+</button></div>`)}
      </div>
      ${freeGift ? '' : `<button class="rm" data-ck="${esc(i.key)}" data-cq="0">Remove</button>`}
    </div>`;
  }).join('')
  + (sugg.length ? '<div class="d-up"><h6>Complete the pack</h6>' + sugg.map(u =>
      `<div class="pair-row"><img src="${u.img}" alt=""><a href="${u.u}">${esc(u.t)}</a><span class="pr">${money(u.p)}</span><button data-vid="${u.vid}" aria-label="Add ${esc(u.t)}">+</button></div>`).join('') + '</div>' : '');
  const save = CART.total_discount;
  foot.innerHTML = `
    <div class="d-line"><span>Items</span><span>${money(CART.original_total_price)}</span></div>
    ${save ? '<div class="d-line save"><span>Discounts</span><span>−' + money(save) + '</span></div>' : ''}
    <div class="d-line"><span>U.S. shipping</span><span>${CFG.freeShipping ? 'FREE' : 'Calculated at checkout'}</span></div>
    <div class="d-line total"><span>Estimated total</span><span>${money(CART.total_price)}</span></div>
    ${hasInvalidGift ? '<button class="btn" type="button" disabled style="display:flex;justify-content:center">Remove reward to checkout</button>' : '<a class="btn" style="display:flex;justify-content:center" href="/checkout">Checkout</a>'}
    <div class="d-note">${hasInvalidGift ? 'Remove the unavailable reward before checkout' : (CFG.freeShipping ? 'Free U.S. shipping · ' : '') + 'Taxes calculated at checkout · Secure Shopify checkout'}</div>`;
}
if (packBtn) packBtn.onclick = () => { renderCart(); openDrawer(); };
const dClose = $('#dClose'); if (dClose) dClose.onclick = closeDrawer;
if (ovl) ovl.onclick = closeDrawer;
if (drawer) drawer.addEventListener('click', async e => {
  const b = e.target.closest('[data-ck]');
  if (b && !b.disabled){
    b.disabled = true; b.setAttribute('aria-busy','true');
    try{ await cartChange(b.dataset.ck, +b.dataset.cq); }
    catch(_){ toast('Could not update your cart. Please try again.'); }
    finally{ b.disabled = false; b.removeAttribute('aria-busy'); }
  }
});
/* global quick add: any [data-vid] button anywhere (cards, pairs, packlists, journal) */
document.addEventListener('click', async e => {
  const b = e.target.closest('button[data-vid]');
  if (!b || b.disabled) return;
  e.preventDefault(); e.stopPropagation();
  let qty = 1;
  if (b.id === 'pdpAdd'){ const q = $('#pdpQ'); qty = q ? Math.max(1, +q.textContent) : 1; }
  b.disabled = true; b.setAttribute('aria-busy', 'true');
  try{ await cartAdd(b.dataset.vid, qty); }
  catch(e){ toast('Could not update your cart. Please try again.'); }
  finally{ b.disabled = false; b.removeAttribute('aria-busy'); }
}, true);
cartFetch();

/* ================= SAVES (localStorage, object list) ================= */
let saves = [];
try{ saves = JSON.parse(localStorage.getItem('rw_saves2') || '[]'); }catch(e){}
const savedHas = h => saves.some(s => s.h === h);
function paintHearts(){
  $$('.psave').forEach(b => b.classList.toggle('onn', savedHas(b.dataset.h)));
  const chip = $('#savedChip');
  if (chip){
    chip.style.display = saves.length ? '' : 'none';
    chip.textContent = 'Saved · ' + saves.length;
  }
}
document.addEventListener('click', e => {
  const b = e.target.closest('button.psave');
  if (!b) return;
  e.preventDefault(); e.stopPropagation();
  if (savedHas(b.dataset.h)) saves = saves.filter(s => s.h !== b.dataset.h);
  else saves.push({ h: b.dataset.h, t: b.dataset.t, img: b.dataset.img, p: b.dataset.p, u: b.dataset.u });
  try{ localStorage.setItem('rw_saves2', JSON.stringify(saves)); }catch(_){}
  paintHearts();
  toast(savedHas(b.dataset.h) ? 'Saved for later' : 'Removed from saved');
}, true);
const savedChip = $('#savedChip');
if (savedChip) savedChip.onclick = () => {
  const grid = $('#shopGrid'); if (!grid) return;
  grid.innerHTML = saves.map(s => `<article class="pc">
    <button class="psave onn" data-h="${s.h}" data-t="${s.t}" data-img="${s.img}" data-p="${s.p}" data-u="${s.u}" aria-label="Remove from saved">♥</button>
    <a class="pc-link" href="${s.u}"><div class="im"><img src="${s.img}" loading="lazy" alt=""></div>
    <div class="in"><div class="t">${s.t}</div><div class="price">${s.p}</div></div></a></article>`).join('')
    || '<p style="color:#8F8873;padding:40px 0">Nothing saved yet.</p>';
  const sc = $('#shopCount'); if (sc) sc.textContent = saves.length + ' saved for later';
};
paintHearts();

/* ================= SEARCH (Shopify predictive) ================= */
const srch = $('#srch'), srchIn = $('#srchIn'), srchRes = $('#srchRes');
const HELP_SEARCH = [
  { re: /return|refund|exchange/i, t: 'Returns & eligibility', u: '/pages/returns' },
  { re: /ship|delivery|track/i, t: 'Shipping & delivery', u: '/pages/shipping' },
  { re: /contact|support|help|order/i, t: 'Contact ReidWood', u: '/pages/contact' },
  { re: /privacy/i, t: 'Privacy policy', u: '/policies/privacy-policy' },
  { re: /terms/i, t: 'Terms of service', u: '/pages/terms-of-service' }
];
function openSearch(){ if (!srch) return; srch.classList.add('show'); srch.removeAttribute('inert'); srch.setAttribute('aria-hidden','false'); srchIn.value = ''; srchRes.innerHTML = ''; const h = $('#srchHint'); if (h) h.style.display = ''; setTimeout(() => srchIn.focus(), 60); }
function closeSearch(){ if (srch){ srch.classList.remove('show'); srch.setAttribute('aria-hidden','true'); srch.setAttribute('inert',''); } }
const navSearch = $('#navSearch'); if (navSearch) navSearch.onclick = openSearch;
const srchX = $('#srchX'); if (srchX) srchX.onclick = closeSearch;
if (srch) srch.addEventListener('click', e => { if (e.target === srch) closeSearch(); });
let srchT;
if (srchIn) srchIn.addEventListener('input', () => {
  const q = srchIn.value.trim();
  const h = $('#srchHint'); if (h) h.style.display = q ? 'none' : '';
  clearTimeout(srchT);
  if (!q){ srchRes.innerHTML = ''; return; }
  srchT = setTimeout(async () => {
    try{
      const r = await (await fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8')).json();
      const hits = ((r.resources && r.resources.results && r.resources.results.products) || []).filter(p =>
        !RCFG.gift || (String(p.id) !== String(RCFG.gift.productId) && p.handle !== RCFG.gift.handle));
      const help = HELP_SEARCH.filter(x => x.re.test(q)).map(x => `<a class="srch-row srch-help" href="${x.u}">
          <div class="t"><span class="ty">HELP & POLICIES</span>${x.t}</div><span class="pr">→</span></a>`).join('');
      const products = hits.map(p => `<a class="srch-row" href="${p.url}">
          <img src="${p.image || p.featured_image && p.featured_image.url || ''}" alt="">
          <div class="t"><span class="ty">${p.type || ''}</span>${p.title}</div>
          <span class="pr">View →</span></a>`).join('');
      const all = `<a class="srch-all" href="/search?q=${encodeURIComponent(q)}">View all results for “${esc(q)}” →</a>`;
      srchRes.innerHTML = help + products + (help || products ? all : '<div class="srch-hint" style="display:block">Nothing matches that yet. Try "fire", "tent", or "shipping".</div>');
    }catch(e){}
  }, 180);
});
addEventListener('keydown', e => {
  if (e.key === 'Escape'){ closeSearch(); closeDrawer(); closeMenu(); }
  if (e.key === '/' && srch && !srch.classList.contains('show') && !/input|textarea/i.test(document.activeElement.tagName)){ e.preventDefault(); openSearch(); }
});

/* ================= MOBILE MENU + BACK TO TOP ================= */
const mburger = $('#mburger'), mmenu = $('#mmenu');
function closeMenu(){
  if (mmenu){ mmenu.classList.remove('show'); mmenu.setAttribute('aria-hidden','true'); mmenu.setAttribute('inert',''); }
  if (mburger){ mburger.classList.remove('open'); mburger.setAttribute('aria-expanded', 'false'); }
}
if (mburger && mmenu){
  mburger.onclick = () => {
    const open = !mmenu.classList.contains('show');
    mmenu.classList.toggle('show', open);
    mmenu.setAttribute('aria-hidden', String(!open));
    if (open) mmenu.removeAttribute('inert'); else mmenu.setAttribute('inert','');
    mburger.classList.toggle('open', open);
    mburger.setAttribute('aria-expanded', String(open));
  };
  const mmClose = $('#mmClose'); if (mmClose) mmClose.onclick = closeMenu;
  mmenu.addEventListener('click', e => { if (e.target.closest('a')) closeMenu(); });
}
const toTop = $('#toTop');
if (toTop){
  addEventListener('scroll', () => toTop.classList.toggle('show', scrollY > 1400), { passive: true });
  toTop.onclick = () => lenis.scrollTo(0, { duration: .9 });
}

/* ================= ANNOUNCEMENT BAR / STICKY BUY / CAPTURE ================= */
const abarMsgs = $$('#abar span');
/* On phones keep one static, legible offer instead of an 8.5px rotator a cold
   ad click cannot read. */
if (abarMsgs.length > 1 && !matchMedia('(max-width: 860px)').matches){
  let abarI = 0;
  setInterval(() => {
    abarMsgs[abarI].classList.remove('on');
    abarI = (abarI + 1) % abarMsgs.length;
    abarMsgs[abarI].classList.add('on');
  }, 4200);
}
/* sticky buy: on product pages the bar shows whenever the REAL buy button is
   off-screen — including on first paint, before any scroll (on phones the buy
   row starts below the fold, and paid traffic lands directly on the PDP). */
(function stickyBuyCtl(){
  const sb = $('#stickyBuy'); if (!sb || TPL !== 'product') return;
  const buy = $('#pdpAdd');
  if (!buy){ addEventListener('scroll', () => sb.classList.toggle('show', scrollY > 480), { passive: true }); return; }
  /* deterministic rect check (not IntersectionObserver): runs synchronously at boot
     so the bar is already up on first paint when the buy row starts below the fold */
  const upd = () => {
    const r = buy.getBoundingClientRect();
    const belowViewport = r.top > innerHeight;
    const show = (scrollY > 80 && r.bottom < 106) || belowViewport;
    sb.classList.toggle('show', show);
    sb.setAttribute('aria-hidden', String(!show));
    if (show) sb.removeAttribute('inert'); else sb.setAttribute('inert','');
  };
  upd();
  addEventListener('scroll', upd, { passive: true });
  addEventListener('resize', upd, { passive: true });
})();
function captureSet(open){
  const c = $('#capt'); if (!c) return;
  c.classList.toggle('show', !!open);
  c.setAttribute('aria-hidden', String(!open));
  if (open) c.removeAttribute('inert'); else c.setAttribute('inert','');
}
const captX = $('#captX'); if (captX) captX.onclick = () => captureSet(false);
const copyCode = $('[data-copy-code]'); if (copyCode) copyCode.onclick = async () => { try{ await navigator.clipboard.writeText(copyCode.dataset.copyCode || ''); toast('Discount code copied'); }catch(e){ toast('Code: ' + (copyCode.dataset.copyCode || 'TRAIL10')); } };
/* centred on desktop, so it behaves like a modal: click the dimmed page or hit
   Escape to dismiss (the dim is a box-shadow, so listen on the document) */
(function captDismiss(){
  const capt = $('#capt'); if (!capt) return;
  document.addEventListener('click', e => {
    if (!capt.classList.contains('show')) return;
    if (!matchMedia('(min-width: 861px)').matches) return;
    if (capt.contains(e.target)) return;
    captureSet(false);
  }, true);
  addEventListener('keydown', e => {
    if (e.key === 'Escape' && capt.classList.contains('show')) captureSet(false);
  });
})();
(function capture(){
  const capt = $('#capt'); if (!capt || TPL === 'cart') return;
  /* Mobile already has an inline signup section. Do not cover scarce screen
     space with a second email prompt. */
  if (matchMedia('(max-width: 860px)').matches) return;
  let shown = false; try{ shown = !!sessionStorage.getItem('rw_capt'); }catch(e){}
  if (shown) return;
  let fired = false;
  const fire = () => {
    if (fired) return; fired = true;
    try{ sessionStorage.setItem('rw_capt', '1'); }catch(_){}
    captureSet(true);
  };
  if (TPL === 'product'){
    /* paid traffic lands here mid-decision — never interrupt the buy consideration.
       Show only at committed/leaving moments: 8s after a successful add, desktop
       exit-intent, or genuinely deep scroll. */
    window.RW_CAPT_AFTER_ADD = () => setTimeout(fire, 8000);
    document.addEventListener('mouseout', e => { if (!e.relatedTarget && e.clientY <= 0) fire(); });
    addEventListener('scroll', () => { if (scrollY > document.documentElement.scrollHeight * .7) fire(); }, { passive: true });
  } else {
    setTimeout(fire, 45000);
    addEventListener('scroll', () => { if (scrollY > document.documentElement.scrollHeight * .6) fire(); }, { passive: true });
  }
})();
const benchLink = $('#benchListLink');
if (benchLink) benchLink.onclick = e => { e.preventDefault(); captureSet(true); };

/* ================= CURSOR / MAGNETIC / TILT / REVEALS ================= */
/* custom cursor removed: no #cur element, no mousemove/mouseover tracking */
function initMagnetic(){
  if (typeof gsap === 'undefined') return;
  $$('.btn').forEach(b => {
    if (b.dataset.mag) return; b.dataset.mag = 1;
    b.addEventListener('mousemove', e => {
      const r = b.getBoundingClientRect();
      gsap.to(b, { x: (e.clientX - r.left - r.width/2) * .18, y: (e.clientY - r.top - r.height/2) * .3, duration: .4, ease: 'power2.out' });
    });
    b.addEventListener('mouseleave', () => gsap.to(b, { x: 0, y: 0, duration: .5, ease: 'elastic.out(1, .5)' }));
  });
}
function initTilt(){
  $$('.pc').forEach(c => {
    if (c.dataset.tilt) return; c.dataset.tilt = 1;
    c.addEventListener('mousemove', e => {
      const r = c.getBoundingClientRect();
      const rx = ((e.clientY - r.top) / r.height - .5) * -6;
      const ry = ((e.clientX - r.left) / r.width - .5) * 6;
      c.style.transform = 'translateY(-6px) perspective(700px) rotateX(' + rx + 'deg) rotateY(' + ry + 'deg)';
    });
    c.addEventListener('mouseleave', () => { c.style.transform = ''; });
  });
}
/* NOTE: .pdp-info > * and .pdp-gal were removed from this list on purpose —
   they re-hid the product image, price and Add button after first paint until
   GSAP ran (a visible flash + delayed buy box on the exact page paid traffic
   lands on). The buy box must never depend on the animation stack. */
function initReveals(root){
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  (root || document).querySelectorAll('.sec-head, .cat, .pc, .story-blk, .j-card, .j-entry, .bench, .deal, .n-form, .val, .acc, .prose p, .prose img').forEach((el, i) => {
    if (el.dataset.rv) return; el.dataset.rv = 1;
    el.classList.add('rv');
    gsap.to(el, { y: 0, opacity: 1, duration: .8, ease: 'expo.out', delay: (i % 4) * .05,
      scrollTrigger: { trigger: el, start: 'top 92%', once: true } });
  });
}
addEventListener('scroll', () => {
  const n = $('#nav'); if (n) n.classList.toggle('scrolled', scrollY > 80);
}, { passive: true });

/* ================= HOME: hero cinema + chapters ================= */
function initHome(){
  const heroPin = $('#heroPin'); if (!heroPin) return;
  const pin = { trigger: '#heroPin', start: 'top top', end: 'bottom bottom', scrub: true };
  gsap.timeline({ scrollTrigger: pin })
    .to('.hero-c', { yPercent: -26, opacity: 0, ease: 'none', duration: .34 }, 0)
    .to('#scrollCue', { opacity: 0, duration: .08 }, 0)
    .fromTo('#heroLine2', { opacity: 0, y: 50 }, { opacity: 1, y: 0, ease: 'none', duration: .18 }, .38)
    .to('#heroLine2', { opacity: 0, y: -40, ease: 'none', duration: .16 }, .72)
    .to('.hero-stamp', { opacity: 0, duration: .1 }, .8);
  $$('.ridge').forEach(r => gsap.to(r, { yPercent: -(+r.dataset.ridge), ease: 'none', scrollTrigger: pin }));
  gsap.to('.sky', { scale: 1.07, ease: 'none', scrollTrigger: pin });

  /* video scrub: stream directly off the CDN (it supports byte ranges, so seeks work
     without downloading all 19MB first — critical on phones), lerped currentTime */
  const heroVid = $('#heroVid');
  let heroVidReady = false, vidTarget = 0;
  if (heroVid && window.RW_HERO){
    heroVid.addEventListener('loadedmetadata', () => {
      heroVidReady = true;
      $('#hero').classList.add('has-vid');
      try{ heroVid.currentTime = 0.001; }catch(e){}   /* force first-frame paint on iOS */
      ScrollTrigger.create({ ...pin, onUpdate: s => { vidTarget = s.progress * (heroVid.duration || 0); } });
      ScrollTrigger.refresh();
    });
    heroVid.src = window.RW_HERO;
    heroVid.load();
    (function scrubTick(){
      if (heroVidReady && heroVid.duration){
        const cu = heroVid.currentTime, d = vidTarget - cu;
        if (Math.abs(d) > 0.02) heroVid.currentTime = cu + d * 0.22;
      }
      requestAnimationFrame(scrubTick);
    })();
  }

  /* chapters */
  const CH = window.RW_CHAPTERS || [];
  let curCh = -1;
  function setChapter(i){
    if (i === curCh || !CH[i]) return;
    const first = curCh === -1; curCh = i;
    const C = CH[i];
    $$('.ch-bg').forEach(el => el.classList.remove('active'));
    const bg = $('#' + C.bg); if (bg) bg.classList.add('active');
    $$('#chRail b').forEach((b, bi) => b.classList.toggle('on', bi === i));
    const swap = () => {
      $('#chNum').textContent = C.num;
      $('#chWord').textContent = C.word;
      $('#chLine').textContent = C.line;
      $('#chProdImg').src = C.img;
      $('#chProdT').textContent = C.t;
      $('#chProdP').textContent = C.p;
      $('#chProd').setAttribute('href', C.u);
    };
    if (first){ swap(); return; }
    gsap.timeline()
      .to('#chCopy', { y: 26, opacity: 0, duration: .28, ease: 'power2.in' })
      .add(swap)
      .to('#chCopy', { y: 0, opacity: 1, duration: .55, ease: 'expo.out' });
  }
  setChapter(0);
  const el = $('#chapters');
  if (el){
    const drive = prog => setChapter(Math.max(0, Math.min(3, Math.floor(prog * 4.0001))));
    ScrollTrigger.create({ trigger: el, start: 'top top', end: 'bottom bottom', onUpdate: self => drive(self.progress) });
    $$('#chRail b').forEach((b, i) => {
      b.onclick = () => {
        const top = el.getBoundingClientRect().top + scrollY;
        lenis.scrollTo(top + (el.offsetHeight - innerHeight) * ((i + 0.5) / 4), { duration: 0.9 });
      };
    });
    const nativeDrive = () => {
      const r = el.getBoundingClientRect();
      if (r.height > innerHeight && r.top <= 0 && r.bottom >= innerHeight * .5){
        drive(Math.min(.999, -r.top / (r.height - innerHeight)));
      }
    };
    addEventListener('scroll', nativeDrive, { passive: true });
    nativeDrive();
  }

  /* favorites row drag */
  const row = $('#favRow');
  if (row){
    const fl = $('#favL'), fr = $('#favR');
    if (fl) fl.onclick = () => row.scrollBy({ left: -360, behavior: 'smooth' });
    if (fr) fr.onclick = () => row.scrollBy({ left: 360, behavior: 'smooth' });
    let drag = null;
    row.onpointerdown = e => { drag = { x: e.clientX, s: row.scrollLeft }; row.classList.add('dragging'); };
    addEventListener('pointermove', e => { if (drag) row.scrollLeft = drag.s - (e.clientX - drag.x); });
    addEventListener('pointerup', () => { drag = null; row.classList.remove('dragging'); });
  }

  /* embers */
  const cv = $('#embers');
  if (cv){
    const cx2 = cv.getContext('2d');
    let W, H; const embers = [];
    const sizeCv = () => { W = cv.width = cv.offsetWidth || innerWidth; H = cv.height = cv.offsetHeight || innerHeight; };
    sizeCv(); addEventListener('resize', sizeCv);
    for (let i = 0; i < 26; i++) embers.push({ x: Math.random(), y: Math.random(), r: .6 + Math.random()*1.8, s: .12 + Math.random()*.4, o: .2 + Math.random()*.55, w: Math.random()*Math.PI*2 });
    (function tickEmbers(){
      if (W && H){
        cx2.clearRect(0, 0, W, H);
        for (const em of embers){
          em.y -= em.s/H*1.9; em.w += .015; em.x += Math.sin(em.w)*.0004;
          if (em.y < -0.02){ em.y = 1.02; em.x = Math.random(); }
          const flick = .75 + Math.sin(em.w*3)*.25;
          cx2.beginPath(); cx2.arc(em.x*W, em.y*H, em.r, 0, 7);
          cx2.fillStyle = 'rgba(242,117,31,' + (em.o*flick) + ')'; cx2.fill();
        }
      }
      requestAnimationFrame(tickEmbers);
    })();
  }

  /* loader + hero intro */
  let heroPlayed = false;
  function heroIn(){
    if (heroPlayed) return; heroPlayed = true;
    try{
      const split = new SplitText('#heroH', { type: 'words', wordsClass: 'w' });
      gsap.timeline()
        .from('.hero-c .eyebrow', { y: 20, opacity: 0, duration: .7, ease: 'expo.out' })
        .from(split.words, { yPercent: 110, opacity: 0, filter: 'blur(10px)', duration: .9, stagger: .07, ease: 'expo.out' }, '-=.4')
        .from('#heroSub', { y: 30, opacity: 0, duration: .8, ease: 'expo.out' }, '-=.5')
        .from('#heroCta .btn', { y: 24, opacity: 0, duration: .7, stagger: .1, ease: 'expo.out' }, '-=.55')
        .from('.hero-stamp', { scale: 0, rotate: -90, opacity: 0, duration: .8, ease: 'back.out(1.6)' }, '-=.5');
    }catch(e){}
  }
  const loader = $('#loader');
  if (loader){
    gsap.timeline()
      .to('#loader img', { opacity: 1, scale: 1, rotate: 0, duration: .9, ease: 'expo.out' })
      .to('#loader .bar i', { scaleX: 1, duration: .9, ease: 'power2.inOut' }, '-=.4')
      .add(() => { loader.classList.add('done'); heroIn(); })
      .set(loader, { display: 'none', delay: 1 });
    loader.addEventListener('click', () => { loader.classList.add('done'); heroIn(); });
  } else heroIn();

  if (location.hash === '#proven'){
    setTimeout(() => { const p = $('#proven'); if (p) lenis.scrollTo(p, { offset: 0 }); }, 300);
  }
}

/* ================= PRODUCT PAGE ================= */
/* one price renderer for every JS-built card, so the related grid and the
   recently-viewed grid carry the same struck-through compare-at price and
   orange percent badge as the Liquid-rendered cards everywhere else */
function priceHtml(price, compareAt){
  price = +price || 0; compareAt = +compareAt || 0;
  if (!(compareAt > price)) return money(price);
  const pct = Math.round((compareAt - price) / compareAt * 100);
  return '<s>' + money(compareAt) + '</s>' + money(price) + '<span class="badge">-' + pct + '%</span>';
}
function initProduct(){
  const P = window.RW_PRODUCT; if (!P) return;
  /* ===== GALLERY =====
     A scroll-snap track of real slides: mobile swipes natively, desktop gets
     arrows + keyboard, thumbs stay in sync, and any slide opens full screen.
     Nothing swaps an img src, so there is no srcset-vs-src conflict to break. */
  const track = $('#galTrack');
  const slides = track ? Array.from(track.querySelectorAll('.gal-slide')) : [];
  const thumbs = $$('#pdpThumbs .pth');
  const galIdx = $('#galIdx'), galPrev = $('#galPrev'), galNext = $('#galNext');
  let gi = 0, snapping = false;

  /* Centre the active thumb by scrolling ONLY the strip. scrollIntoView was
     scrolling the whole document (block:'nearest' still walks up to the page
     when the strip is partly off-screen) and fought Lenis, which read on
     desktop as the page jumping up or down on every arrow click. */
  const thumbWrap = $('#pdpThumbs');
  function revealThumb(i){
    const at = thumbs[i];
    if (!thumbWrap || !at) return;
    const target = at.offsetLeft - thumbWrap.offsetLeft - (thumbWrap.clientWidth - at.clientWidth) / 2;
    const max = thumbWrap.scrollWidth - thumbWrap.clientWidth;
    thumbWrap.scrollTo({ left: Math.max(0, Math.min(max, target)), behavior: 'smooth' });
  }
  function paintGallery(i){
    gi = i;
    if (galIdx) galIdx.textContent = i + 1;
    thumbs.forEach((t, ti) => { const active = ti === i; t.classList.toggle('on', active); t.setAttribute('aria-pressed', String(active)); });
    revealThumb(i);
    if (galPrev) galPrev.disabled = i <= 0;
    if (galNext) galNext.disabled = i >= slides.length - 1;
  }
  function goTo(i, smooth){
    if (!track || !slides.length) return;
    i = Math.max(0, Math.min(slides.length - 1, i));
    snapping = true;
    track.scrollTo({ left: i * track.clientWidth, behavior: smooth === false ? 'auto' : 'smooth' });
    paintGallery(i);
    setTimeout(() => { snapping = false; }, 420);
  }
  if (track && slides.length){
    paintGallery(0);
    /* keep state honest when the user swipes instead of using the controls.
       Debounced on a timer rather than requestAnimationFrame: rAF is frozen in
       background/hidden tabs, which would leave the counter and thumbs stuck. */
    let syncT;
    track.addEventListener('scroll', () => {
      if (snapping) return;
      clearTimeout(syncT);
      syncT = setTimeout(() => {
        const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== gi && slides[i]) paintGallery(i);
      }, 90);
    }, { passive: true });
    if (galPrev) galPrev.onclick = () => goTo(gi - 1);
    if (galNext) galNext.onclick = () => goTo(gi + 1);
    thumbs.forEach(t => t.addEventListener('click', () => goTo(+t.dataset.i)));
    addEventListener('resize', () => goTo(gi, false), { passive: true });
    addEventListener('keydown', e => {
      if (/input|textarea|select/i.test(document.activeElement.tagName)) return;
      if ($('#srch') && $('#srch').classList.contains('show')) return;
      if (lb && lb.classList.contains('show')) return;      /* viewer owns the keys */
      if (e.key === 'ArrowLeft'){ e.preventDefault(); goTo(gi - 1); }
      else if (e.key === 'ArrowRight'){ e.preventDefault(); goTo(gi + 1); }
    });
  }

  /* full-screen viewer, built once on first use */
  let lb = null, lbReturnFocus = null;
  function openLightbox(i){
    if (!slides.length) return;
    if (!lb){
      lb = document.createElement('div');
      lb.id = 'galLB';
      lb.setAttribute('role','dialog');
      lb.setAttribute('aria-modal','true');
      lb.setAttribute('aria-label','Product photo viewer');
      lb.innerHTML = '<button class="lb-x" aria-label="Close">&#10005;</button>'
        + '<button class="lb-nav prev" aria-label="Previous photo">&#8249;</button>'
        + '<img alt=""><button class="lb-nav next" aria-label="Next photo">&#8250;</button>'
        + '<div class="lb-count"></div>';
      document.body.appendChild(lb);
      lb.querySelector('.lb-x').onclick = closeLightbox;
      lb.querySelector('.lb-nav.prev').onclick = e => { e.stopPropagation(); showLB(lbI - 1); };
      lb.querySelector('.lb-nav.next').onclick = e => { e.stopPropagation(); showLB(lbI + 1); };
      lb.addEventListener('click', e => { if (e.target === lb) closeLightbox(); });
      addEventListener('keydown', e => {
        if (!lb || !lb.classList.contains('show')) return;
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowLeft') showLB(lbI - 1);
        if (e.key === 'ArrowRight') showLB(lbI + 1);
      });
    }
    showLB(i);
    lbReturnFocus = document.activeElement;
    lb.classList.add('show');
    lb.querySelector('.lb-x').focus();
    /* pad by exactly the scrollbar width, otherwise hiding overflow reclaims
       ~15px and the whole page slides sideways as the viewer opens */
    const sbw = window.innerWidth - document.documentElement.clientWidth;
    if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
    document.body.style.overflow = 'hidden';
    if (lenis && lenis.stop) try{ lenis.stop(); }catch(e){}
  }
  let lbI = 0;
  function showLB(i){
    lbI = Math.max(0, Math.min(slides.length - 1, i));
    const src = slides[lbI].querySelector('img');
    lb.querySelector('img').src = src.dataset.full || src.currentSrc || src.src;
    lb.querySelector('.lb-count').textContent = (lbI + 1) + ' / ' + slides.length;
    lb.querySelector('.lb-nav.prev').disabled = lbI <= 0;
    lb.querySelector('.lb-nav.next').disabled = lbI >= slides.length - 1;
  }
  function closeLightbox(){
    if (!lb) return;
    lb.classList.remove('show');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
    if (lenis && lenis.start) try{ lenis.start(); }catch(e){}
    goTo(lbI, false);   /* leave the inline gallery on whatever they were looking at */
    if (lbReturnFocus && lbReturnFocus.focus) lbReturnFocus.focus();
  }
  const galZoom = $('#galZoom');
  if (galZoom) galZoom.onclick = () => openLightbox(gi);
  slides.forEach((s, i) => s.querySelector('img').addEventListener('click', () => openLightbox(i)));
  /* variant picker: keep every add button, the express-checkout form, AND every
     visible price pointed at the chosen variant. The displayed price must always
     equal what lands in the cart — anything else is a bait-and-switch at the ATC. */
  function paintAddPrice(p){
    const add = $('#pdpAdd'); if (!add || !p) return;
    const q = Math.max(1, +($('#pdpQ') && $('#pdpQ').textContent) || 1);
    add.textContent = (q > 1 ? `Add ${q} to cart` : 'Add to cart') + ' · ' + money(p * q);
  }
  function paintPrice(p, cap){
    const el = $('#pdpPrice');
    if (el && p){
      let html = '';
      if (cap > p) html += '<s>' + money(cap) + '</s>';
      html += money(p);
      if (cap > p) html += ' <span class="badge">SAVE ' + Math.round((cap - p) / cap * 100) + '%</span>';
      el.innerHTML = html;
    }
    const sp = $('#sbPrice'); if (sp && p) sp.innerHTML = priceHtml(p, cap);
    paintAddPrice(p);
  }
  const qtyEl = $('#pdpQ');
  if (qtyEl){
    const paintQty = q => {
      q = Math.max(1, Math.min(20, q));
      qtyEl.textContent = q;
      const minus = $('[data-pdp-qty="-1"]'); if (minus) minus.disabled = q <= 1;
      const hint = $('#pdpQtyHint');
      if (hint){
        const threshold = +RCFG.percentThreshold || 10000;
        const projected = P.p * q;
        const away = Math.max(0, threshold - projected);
        hint.textContent = away
          ? `${money(away)} more in eligible merchandise unlocks ${RCFG.percent}% off.`
          : `This selection reaches ${RCFG.percent}% off.`;
      }
      paintAddPrice(P.p);
    };
    $$('[data-pdp-qty]').forEach(b => b.addEventListener('click', () => paintQty((+qtyEl.textContent || 1) + (+b.dataset.pdpQty || 0))));
    paintQty(1);
  }
  const varSel = $('#pdpVar');
  if (varSel) varSel.addEventListener('change', () => {
    const vid = varSel.value;
    const add = $('#pdpAdd'); if (add) add.dataset.vid = vid;
    const sb = $('#sbBtn'); if (sb) sb.dataset.vid = vid;
    const f = $('#pdpFormVid'); if (f) f.value = vid;
    P.vid = vid;
    const opt = varSel.options[varSel.selectedIndex];
    if (opt){
      /* jump the slider to that variant's photo instead of swapping a src */
      if (opt.dataset.img && slides.length){
        const key = (opt.dataset.img.split('?')[0] || '').split('/').pop();
        const hit = slides.findIndex(s => (s.querySelector('img').src || '').indexOf(key) > -1);
        if (hit > -1) goTo(hit);
      }
      const np = +opt.dataset.p, ncap = +opt.dataset.cap || 0;
      if (np){ P.p = np; paintPrice(np, ncap); }
    }
  });
  $$('#pdpVariantPicker input[name="variant-choice"]').forEach(radio => {
    radio.addEventListener('change', () => {
      if (!radio.checked || !varSel) return;
      varSel.value = radio.value;
      varSel.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
  /* star badge is a shortcut to the proof */
  document.addEventListener('click', e => {
    const b = e.target.closest('.pdp-review-link,.jdgm-preview-badge'); if (!b) return;
    e.preventDefault();
    const band = document.querySelector('.reviews-band');
    if (band) lenis.scrollTo(band, { offset: -80 });
  });
  /* sticky bar */
  const sbI = $('#sbImg'), sbT = $('#sbTitle'), sbP = $('#sbPrice'), sbB = $('#sbBtn');
  if (sbI){
    sbI.src = (P.img || '').replace('width=400', 'width=120') || P.img;
    sbT.textContent = P.t; sbP.innerHTML = priceHtml(P.p, P.cap); sbB.dataset.vid = P.vid;
    if (P.liquidAvailable === false){ sbB.disabled = true; sbB.textContent = 'Sold out'; }
  }
  /* Honest dispatch guidance. Supplier SLAs vary across this mixed catalog, so
     do not manufacture one universal arrival date and present it as a promise. */
  const d = $('#dispatch');
  if (d){
    const shipLead = CFG.freeShipping ? '<b>Free U.S. shipping</b>' : '<b>Shipping shown at checkout</b>';
    d.innerHTML = shipLead + ' · tracking sent after dispatch · delivery timing varies by item and destination';
  }
  /* related grid via native recommendations (the pairs box is server-rendered, cross-category) */
  fetch('/recommendations/products.json?product_id=' + P.id + '&limit=6')
    .then(r => r.json())
    .then(data => {
      const recs = (data.products || []).filter(p => p.id !== P.id &&
        (!RCFG.gift || (String(p.id) !== String(RCFG.gift.productId) && p.handle !== RCFG.gift.handle)));
      const rel = recs.slice(0, 4), rg = $('#relGrid');
      if (rel.length && rg){
        const sized = (u, w) => u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : '';
        rg.innerHTML = rel.map(p => {
          const variants = p.variants || [], v = variants.find(x => x.available) || variants[0];
          const action = variants.length === 1 && v && v.available !== false
            ? `<button class="qadd" data-vid="${v.id}" aria-label="Add ${p.title} to cart">+</button>`
            : `<a class="qadd" href="/products/${p.handle}" aria-label="Choose options for ${p.title}">→</a>`;
          return `<article class="pc">${action}<a class="pc-link" href="/products/${p.handle}">
            <div class="im"><img src="${sized(p.featured_image, 400)}" loading="lazy" alt=""></div>
            <div class="in"><div class="type">${p.type || ''}</div><div class="t">${p.title}</div>
            <div class="price">${variants.length > 1 ? 'From ' : ''}${priceHtml(p.price, p.compare_at_price)}</div></div></a></article>`;
        }).join('');
        initTilt();
      }
    }).catch(() => {});
  /* recently viewed */
  let rv = []; try{ rv = JSON.parse(localStorage.getItem('rw_recent2') || '[]'); }catch(e){}
  const isStoredGift = x => RCFG.gift && (String(x.id) === String(RCFG.gift.productId) || x.handle === RCFG.gift.handle);
  const show = rv.filter(x => x.handle !== P.handle && !isStoredGift(x)).slice(0, 4);
  rv = [P, ...rv.filter(x => x.handle !== P.handle && !isStoredGift(x))].filter(x => !isStoredGift(x)).slice(0, 8);
  try{ localStorage.setItem('rw_recent2', JSON.stringify(rv)); }catch(e){}
  const rw = $('#recentWrap');
  if (rw && show.length){
    rw.style.display = '';
    /* p.cap is the compare-at price; entries saved before this shipped simply
       have none and fall back to a plain price */
    $('#recentGrid').innerHTML = show.map(p => `<a class="pc" href="${p.u}">
      <div class="im"><img src="${p.img}" loading="lazy" alt=""></div>
      <div class="in"><div class="t">${p.t}</div><div class="price">${priceHtml(p.p, p.cap)}</div></div></a>`).join('');
  }
}

/* ================= BOOT ================= */
/* each init is isolated: an animation failure must never take the cart down with it */
try{ initHome(); }catch(e){}
try{ initProduct(); }catch(e){}
try{ initReveals(document); }catch(e){}
try{ initMagnetic(); }catch(e){}
try{ initTilt(); }catch(e){}
try{ ScrollTrigger.refresh(); }catch(e){}
/* newsletter forms reload the page with ?customer_posted=true — confirm it */
if (location.search.indexOf('customer_posted=true') > -1){
  const capt = $('#capt'), code = CFG.firstOrderCode || 'TRAIL10', percent = CFG.firstOrderPercent || 10, minimum = rewardMoney(CFG.firstOrderMinimum || 4000);
  if (capt){
    const title = capt.querySelector('[data-capt-title]'), copy = capt.querySelector('[data-capt-copy]'), form = capt.querySelector('form'), box = $('#captCode');
    if (title) title.textContent = `Your ${percent}% code is ready`;
    if (copy) copy.textContent = `Use it on a first order of ${minimum} or more. One use per customer. It does not combine with REIDWOOD Pack Rewards or GOOGLE15.`;
    if (form) form.hidden = true;
    if (box) box.hidden = false;
    setTimeout(() => captureSet(true), 350);
  }
  setTimeout(() => toast(`Your ${percent}% code: ${code}`), 600);
}
})();

